import React from 'react';
import './Features.css';

const IconFrame = ({ children }) => (
  <span className="feature-icon" aria-hidden="true">
    {children}
  </span>
);

const features = [
  {
    title: 'Rechargez votre compte',
    description:
      'Orange Money, Sama Money, Stripe ou un code de recharge : le solde arrive sur vos cartes cantine.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <rect x="3" y="6" width="18" height="12" rx="2" />
        <path d="M3 10h18M7 14h4" />
      </svg>
    ),
  },
  {
    title: 'Gérez vos cartes',
    description:
      'Consultez le statut, le titulaire et l’historique de chaque carte, société par société.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <rect x="3" y="5" width="18" height="14" rx="2" />
        <circle cx="8" cy="12" r="1.4" />
        <path d="M12 11h6M12 14h4" />
      </svg>
    ),
  },
  {
    title: 'Apple Wallet',
    description:
      'Ajoutez le pass : Boursier en bleu, Standard en vert, autre en gris. Un tap ouvre Shini Pay.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M7 7h10v12H7z" />
        <path d="M7 10h10M10 4v3M14 4v3" />
      </svg>
    ),
  },
  {
    title: 'Historique clair',
    description:
      'Toutes les transactions, avec le détail par carte — pour suivre les repas sans surprise.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <circle cx="12" cy="12" r="8" />
        <path d="M12 8v5l3 2" />
      </svg>
    ),
  },
  {
    title: 'Sécurité biométrique',
    description:
      'Empreinte ou Face ID pour ouvrir l’app. Les données biométriques restent sur l’appareil.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <rect x="6" y="10" width="12" height="10" rx="2" />
        <path d="M9 10V8a3 3 0 0 1 6 0v2" />
      </svg>
    ),
  },
  {
    title: 'Portail de gestion',
    description:
      'Le même compte, sur le web : gérez votre carte depuis cards.servair.shinitech.com.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <rect x="3" y="4" width="18" height="14" rx="2" />
        <path d="M8 21h8M12 18v3" />
      </svg>
    ),
  },
];

const Features = () => (
  <section id="features" className="features">
    <div className="container">
      <h2 className="section-title">Tout pour la carte cantine</h2>
      <p className="section-subtitle">
        Shini Pay sert à recharger et suivre vos cartes. Apple Wallet les garde à portée de main.
      </p>
      <ul className="features-grid">
        {features.map((feature) => (
          <li key={feature.title} className="feature-card">
            <IconFrame>{feature.icon}</IconFrame>
            <h3 className="feature-title">{feature.title}</h3>
            <p className="feature-description">{feature.description}</p>
          </li>
        ))}
      </ul>
      <div className="feature-shots">
        <figure>
          <img src="/screenshots/home-1.PNG" alt="Accueil Shini Pay : solde et recharges Orange Money et Sama Money" />
          <figcaption>Recharge depuis l’app</figcaption>
        </figure>
        <figure>
          <img src="/screenshots/cards-1.PNG" alt="Liste des cartes cantine dans Shini Pay" />
          <figcaption>Vos cartes, en un coup d’œil</figcaption>
        </figure>
      </div>
    </div>
  </section>
);

export default Features;
